import i18next from 'i18next';
import {
  clone,
} from 'ramda';


// TODO consolidate these two
export const getPaymentStatusText = (team) => {
  return  i18next.t('private:paymentStatuses.' + getPaymentStatus(team));
};


// TODO this is not really nice logic. Payment part needs to be
// refactored and moved to server
export const getPaymentStatus = (team) => {
  const po = clone(team.purchaseOrders),
        p = clone(team.payments);

  let status, poStatus, paymentStatus;
  
  if (po && po.length) {
    poStatus = po[0].status;
  }
  
  if (p && p.length) {
    paymentStatus = (p[0].voistlus === 'Y' || p[0].success) ? 'CONFIRMED' : 'NOT_PAID';
  }

  if (poStatus === 'PO_SUBMITTED' && paymentStatus === 'CONFIRMED') {
    status = paymentStatus;
  } else if (poStatus === 'PO_SUBMITTED' && paymentStatus !== 'CONFIRMED') {
    status = poStatus;
  } else {
    status = paymentStatus;
  }

  return status || 'NOT_PAID';
};

export const getPaymentTotal = (team) => {
  const p = clone(team.payments);

  return (p && p.length && p[0].success) ? p[0].total + '€' : null;
};



// WEBPACK FOOTER //
// ./src/private/common/utils/paymentStatus.js